// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3W0hi","inner":"Form_inner__1EmN0","range":"Form_range__1JSn_","name":"Form_name__d8htZ","actions":"Form_actions__XWVGK"};